/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLocaleConsentAcceptanceRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_locale_consent_acceptance.pb'
import {GetLocaleConsentAcceptanceResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/get_locale_consent_acceptance.pb'


export const getLocaleConsentAcceptance = (request: GetLocaleConsentAcceptanceRequest, options?: CashRequestOptions) => post<GetLocaleConsentAcceptanceRequest, GetLocaleConsentAcceptanceResponse>("/cash-app/community/get-locale-consent-acceptance", request, {...options, rejectOnError: true })